import React from 'react';

import { ExtratoRoyaltyListComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function ExtratoRoyaltyList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_EXTRATO_ROYALTIES_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ExtratoRoyaltyListComp />
        </ListagemProvider>
    );
}
